import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-phone-number-row',
  templateUrl: './phone-number-row.component.html',
  styleUrls: ['./phone-number-row.component.scss']
})
export class PhoneNumberRowComponent {
  @Input() number;
  @Input() campaignId;

  @Output() public setMainPhoneNumber = new EventEmitter();
  @Output() public setMainEeaPhoneNumber = new EventEmitter();
  @Output() public removePhoneNumber = new EventEmitter();

  constructor(private router: Router) {}

  onEdit() {
    this.router.navigate(['phone-numbers', this.number.id, 'custom']);
  }
}
